import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EstudoDetailComponent } from './estudo-detail.component';
import { InstrucoesDetailComponent } from './instrucoes-detail.component';
import { EstudoPreliminarDetailComponent } from './estudo-preliminar-detail.component';
import { DadosPessoaisDetailComponent } from './dados-pessoais-detail.component';
import { ConclusaoDetailComponent } from './conclusao-detail.component';
import { EstudoRoutingModule } from './estudo.routes';
import { EstudoService } from './estudo.service';
import { AlunoSaeService } from '../aluno/aluno-sae.service';
import { GrupoFamiliarService } from '../grupo-familiar/grupo-familiar.service';
import { GrupoFamiliarModule } from '../grupo-familiar/grupo-familiar.module';
import { QuestionarioDinamicoModule } from 'unb-questionario-componente';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { RespostaListaModule } from 'unb-questionario-componente';
import { ValidacaoMensagemModule } from '../validacao/validacao.mensagem.module';
import { EstudoListModule } from '../estudo-list/estudo-list.module';

/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatRadioModule,
  MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatCheckboxModule, MatTableModule,
  MatPaginatorModule, MatSortModule, MatCardModule } from '@angular/material';
import { PagerComponent} from '../paginator/pager.component';


@NgModule({
    declarations: [
      EstudoDetailComponent,
      InstrucoesDetailComponent,
      EstudoPreliminarDetailComponent,
      DadosPessoaisDetailComponent,
      ConclusaoDetailComponent
    ],
    exports: [
      InstrucoesDetailComponent,
      EstudoPreliminarDetailComponent,
      DadosPessoaisDetailComponent,
      ConclusaoDetailComponent
    ],
    imports: [
      FormsModule, CommonModule,
      QuestionarioDinamicoModule,
      RespostaListaModule,
      GrupoFamiliarModule,
      EstudoListModule,
      ValidacaoMensagemModule,
      MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatProgressBarModule,
      MatSnackBarModule, MatRadioModule, MatTabsModule, MatSortModule, MatCheckboxModule, MatTableModule,
      MatPaginatorModule, MatCardModule,
      EstudoRoutingModule
    ],
    providers: [
      EstudoService, PagerComponent, GrupoFamiliarService, AlunoSaeService
    ]
})
export class EstudoModule {
}
